// extracted by mini-css-extract-plugin
module.exports = {"selectLabTestCard":"SelectLabTestCard_selectLabTestCard__9Zh6j","icon_wrap":"SelectLabTestCard_icon_wrap__8ZD_I","content":"SelectLabTestCard_content__RqcxA"};